function initMap() {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var _styledMapType = new google.maps.StyledMapType(
		[{
				"elementType": "geometry",
				"stylers": [{
					"color": "#ebe3cd"
				}]
			},
			{
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#523735"
				}]
			},
			{
				"elementType": "labels.text.stroke",
				"stylers": [{
					"color": "#f5f1e6"
				}]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [{
					"color": "#c9b2a6"
				}]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "geometry.stroke",
				"stylers": [{
					"color": "#dcd2be"
				}]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#ae9e90"
				}]
			},
			{
				"featureType": "landscape.natural",
				"elementType": "geometry",
				"stylers": [{
					"color": "#dfd2ae"
				}]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [{
					"color": "#dfd2ae"
				}]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#93817c"
				}]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry.fill",
				"stylers": [{
					"color": "#a5b076"
				}]
			},
			{
				"featureType": "poi.park",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#447530"
				}]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [{
					"color": "#f5f1e6"
				}]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [{
					"color": "#fdfcf8"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [{
					"color": "#f8c967"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [{
					"color": "#e9bc62"
				}]
			},
			{
				"featureType": "road.highway.controlled_access",
				"elementType": "geometry",
				"stylers": [{
					"color": "#e98d58"
				}]
			},
			{
				"featureType": "road.highway.controlled_access",
				"elementType": "geometry.stroke",
				"stylers": [{
					"color": "#db8555"
				}]
			},
			{
				"featureType": "road.local",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#806b63"
				}]
			},
			{
				"featureType": "transit.line",
				"elementType": "geometry",
				"stylers": [{
					"color": "#dfd2ae"
				}]
			},
			{
				"featureType": "transit.line",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#8f7d77"
				}]
			},
			{
				"featureType": "transit.line",
				"elementType": "labels.text.stroke",
				"stylers": [{
					"color": "#ebe3cd"
				}]
			},
			{
				"featureType": "transit.station",
				"elementType": "geometry",
				"stylers": [{
					"color": "#dfd2ae"
				}]
			},
			{
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [{
					"color": "#b9d3c2"
				}]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#92998d"
				}]
			}
		], { name: 'Styled Map' });

	function _isSP() {
		return NS.getBreakPoint() == 'sm';
	}

	function _setMarkerAndStyle(map) {
		var image = {
			url: _markerImgUrl,
			scaledSize: new google.maps.Size(60, 74)
			// ↑ここで画像のサイズを指定
		}
		//Associate the styled map with the MapTypeId and set it to display.
		map.mapTypes.set('styled_map', _styledMapType);
		map.setMapTypeId('styled_map');
		var marker = new google.maps.Marker({
			map: map,
			title: "Hello World!",
			icon: image,
			// animation: google.maps.Animation.DROP,
			position: _darumaLatLng,
		});
	}

	///////////////////////////////////////////
	var _darumaLatLng = new google.maps.LatLng(35.25138511122367, 139.1596177);
	var _markerImgUrl = script_config.theme_root + '/assets/img_daruma/map_marker@2x.png';
	var _mapOption = {
		center: _darumaLatLng,
		zoom: (_isSP()) ? 15 : 16,
		disableDefaultUI: true,
		zoomControl: true,
		scaleControl: true,
	};

	///////////////////////////////////////////
	// だるまの位置マーカー
	var setupNormalMap = function(domId) {
		if (document.getElementById(domId) == undefined) {
			return;
		}
		// Create a map object, and include the MapTypeId to add
		// to the map type control.
		var map = new google.maps.Map(document.getElementById(domId), _mapOption);
		_setMarkerAndStyle(map);
	};

	///////////////////////////////////////////
	// 道順
	var setupRouteMap = function(domId) {
		if (document.getElementById(domId) == undefined) {
			return;
		}
		var kmlData = '<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2"><Document><Style id="LineStyle1">  <LineStyle>  <color>7f0000ff</color>  <width>20</width>  </LineStyle></Style><Placemark><styleUrl>#LineStyle1</styleUrl><LineString><coordinates>139.15746688842773,35.25074037219578 139.15761709213257,35.25074037219578 139.15761709213257,35.25082798748196 139.15936589241028,35.250806083669275 139.15936589241028,35.25131425059901</coordinates></LineString></Placemark></Document></kml>';
		var geoxml = null;

		function initialize() {
			var map = new google.maps.Map(document.getElementById(domId), _mapOption);
			geoXml = new geoXML3.parser({
				map: map,
				// singleInfoWindow: true,
				clickable: false
			});
			geoXml.parseKmlString(kmlData);
			// from google's dashed line example: 
			// https: //developers.google.com/maps/documentation/javascript/examples/overlay-symbol-dashed
			// Define a symbol using SVG path notation, with an opacity of 1.
			// var lineSymbol = {
			//   path: 'M 0,-1 0,1',
			//   strokeOpacity: 1,
			//   scale: 4
			// };	
			var lineSymbol = {
				path: 'M-1,0a1,1 0 1,0 2,0a1,1 0 1,0 -2,0', // circle
				strokeOpacity: 1,
				scale: 1,
				strokeWeight: 3,
				strokeColor: "#8d0f27",
			};
			for (var i = 0; i < geoXml.docs[0].gpolylines.length; i++) {
				geoXml.docs[0].gpolylines[i].setOptions({
					strokeOpacity: 0,
					icons: [{
						icon: lineSymbol,
						offset: '0',
						repeat: '10px'
					}],
					clickable: false,
				});
			}
			_setMarkerAndStyle(map);
			if (_isSP()) {
				map.setZoom(17);
			} else {
				map.setZoom(18);
			}
		}
		google.maps.event.addDomListener(window, "load", initialize);
	};

	///////
	setupNormalMap('map');
	setupRouteMap('map--from-castle');
}
$(function() {
	initMap();
});
